
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 11a3 3 0 10-3-3 2.987 2.987 0 003 3zm-8 0a3 3 0 10-3-3 2.987 2.987 0 003 3zm0 2c-2.33 0-7 1.17-7 3.5V18a1 1 0 001 1h12a1 1 0 001-1v-1.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05.02.01.03.03.04.04A4.16 4.16 0 0117 16.5V18a3 3 0 01-.18 1H22a1 1 0 001-1v-1.5c0-2.33-4.67-3.5-7-3.5z"}})])
          )
        }
      }
    